import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { WebService } from './web.service';
import { AppGlobals } from './app.global';
import { AppConstant } from './app.constant';

@Injectable()
export class CommonService {

    constructor(private http: HttpClient,public webService:WebService,public appGlobal:AppGlobals,public appConstant:AppConstant) {

    }



    onlyNumberKey(event) {
        return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }

    onlyDecimalKey(event)
    {
        var charCode = (event.which) ? event.which : event.keyCode;
        if (charCode != 46 && charCode > 31 
          && (charCode < 48 || charCode > 57))
           return false;

        return true;
    }


    getDeviceTrakingDetailsByDeviceId(objparamterDeviceModel) 
    {
        return this.webService.Post(objparamterDeviceModel, 'DeviceTrackingDetailsAPI/GetDeviceHistory');
    }

    setEventDeviceRequestLogger(objparamterDeviceModel) 
    {
        return this.webService.Post(objparamterDeviceModel, 'DeviceTrackingDetailsAPI/EventDeviceRequestLogger');
    }
    
    SendCommandToDevice(objparamterDeviceModel) 
    {
        return this.http.get('https://platform.clickatell.com/messages/http/send?apiKey='+ this.appGlobal.clickATelAPIKey +'&to='+ objparamterDeviceModel.SimPhoneNo  +'&content='+ objparamterDeviceModel.Content +'&from='+ this.appGlobal.clickATelServiceProviderNo +'').toPromise();
    }

    getIpAddress() {
        return this.http
            .get('https://jsonip.com')
            .map(response => response || {})
            .catch(this.handleError);
    }

    private handleError(error: HttpErrorResponse):
        Observable<any> {
        //Log error in the browser console
        console.error('observable error: ', error);
        return Observable.throw(error);
    }


}



// WEBPACK FOOTER //
// ./src/app/service/CommonService.ts